import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import highlight from 'rehype-highlight';
import 'highlight.js/styles/github.css';
import '../docs/Markdown.css';
import ErrorDialog from '../pages/ErrorDialog';
import { Messages } from '../constants/Messages';

const Manual: React.FC = () => {
    const [markdown, setMarkdown] = useState('');
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleCloseErrorDialog = () => {
        setErrorDialogOpen(false);
    };

    useEffect(() => {
        let isMounted = true;
        const manualPath = `${process.env.PUBLIC_URL}/docs/Manual.md`;

        fetch(manualPath)
            .then(response => response.text())
            .then(text => {
                if (isMounted) setMarkdown(text);
            })
            .catch(error => {
                setErrorMessage(Messages.MARKDOWN_LOAD_ERROR);
                setErrorDialogOpen(true);
            });

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <>
            <ErrorDialog open={errorDialogOpen} errorMessage={errorMessage} onClose={handleCloseErrorDialog} />
            <div className='manual'>
                <ReactMarkdown rehypePlugins={[highlight]}>
                    {markdown}
                </ReactMarkdown>
            </div>
        </>
    );
};

export default Manual;
